import '../css/blog-index.scss'

import React, { Component } from 'react'
import { render } from 'react-dom'

import { Api } from './Api'

import { FilterBar } from './components/FilterBar'
import { Posts } from './components/Posts'

class BlogIndex extends Component {

	constructor( props ) {
		super( props )

		this.state = {
			'paged': 1,
			'cat': false,
			'posts': {
				'posts': [],
				'found_posts': 0,
				'max_num_pages': 0,
			},
			'categories' : [],
			'isSearchingPosts': true,
		}

		this.api = new Api;
	}

	componentDidMount() {
		this.getPosts( this.state.paged, this.state.cat )
		this.getCategories()
	}

	scrollToTop() {
		window.scroll({
			behavior: 'smooth',
			left: 0,
			top: document.getElementById('bi-app').offsetTop
		});
	}

	getPosts( paged, cat, scrollTop = false ) {
		this.setState({ isSearchingPosts: true })

		if ( scrollTop ) {
			this.scrollToTop()
		}

		this.api.getPosts( paged, cat )
			.then( data => {
				this.setState({ 
					posts: data,
					isSearchingPosts: false,
				})
			})
	}

	getCategories() {
		this.api.getCategories()
			.then( data => {
				this.setState({ 
					categories: data
				})
			})
	}

	updateCategory( categoryId ) {
		this.setState({ 
			paged: 1,
			cat: categoryId
		})
		this.getPosts( 1, categoryId )
	}
	
	updatePage( page, scrollTop ) {
		this.setState({ paged: page })
		this.getPosts( page, this.state.cat, true )
	}

	render() {
		return (
			<div className="bi-blog-index">
				<FilterBar
					categories={ this.state.categories }
					currentCategory={ this.state.cat }
					updateCategory={ this.updateCategory.bind( this ) }
				/>

				<Posts 
					isSearchingPosts={ this.state.isSearchingPosts }
					posts={ this.state.posts } 
					updatePage={ this.updatePage.bind( this ) }
					currentCategory={ this.state.cat }
					paged={ this.state.paged }
				/>
			</div>
		)
	}

}

window.React = React

render(
	<BlogIndex />,
	document.getElementById('bi-app')
)